import React from 'react';
import { comparisonRows } from '../mock';
import { Check, Minus } from 'lucide-react';
import { SectionHeader } from './Services';

const Comparison = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="squiggle-bg" />
      <div className="max-w-5xl mx-auto px-6 relative">
        <SectionHeader
          eyebrow="Self-Study vs Us"
          title={<>Why train with us over <em className="italic">self-study</em>?</>}
          description="Save months of confusion — structured curriculum, live simulations, and Big 14 placement support you can’t get from YouTube videos."
        />

        <div className="card-soft rounded-2xl overflow-hidden">
          <div className="grid grid-cols-3 text-sm font-body">
            <div className="p-5 md:p-6 border-b border-[#143324]/10 bg-[#efe9d9] text-[#143324] font-medium">Benefits</div>
            <div className="p-5 md:p-6 border-b border-l border-[#143324]/10 bg-[#efe9d9] text-[#143324] font-medium text-center">Self Study</div>
            <div className="p-5 md:p-6 border-b border-l border-[#143324]/10 bg-[#143324] text-[#f2eee4] font-medium text-center">Eduvantage</div>

            {comparisonRows.map((row, i) => (
              <React.Fragment key={i}>
                <div className={`p-5 md:p-6 ${i < comparisonRows.length - 1 ? 'border-b' : ''} border-[#143324]/10 text-[#1c1c1c]`}>
                  {row.benefit}
                </div>
                <div className={`p-5 md:p-6 ${i < comparisonRows.length - 1 ? 'border-b' : ''} border-l border-[#143324]/10 flex items-center justify-center text-[#143324]/40`}>
                  <Minus size={20} strokeWidth={2} />
                </div>
                <div className={`p-5 md:p-6 ${i < comparisonRows.length - 1 ? 'border-b' : ''} border-l border-[#143324]/10 flex items-center justify-center text-[#143324] bg-[#f0ead9]`}>
                  <Check size={20} strokeWidth={2} />
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
